import Vue from "vue";
import vuex from "vuex";
import errorLog from "./modules/errorLog";
import user from "./modules/user";
import message from "./modules/message";
import cycle from "./modules/cycle";
import payeh from "./modules/payeh";
import hozoor from "./modules/hozoor";
import khorooj from "./modules/khorooj";
import transfer from "./modules/transfer";
import resume from "./modules/resume";
import salary from "./modules/salary";
import schools from "./modules/schools";
import homeRequest from "./modules/home-request";
import sabtenam from "./modules/sabtenam";
import links from "./modules/links";
import ertebat from "./modules/ertebat";
import madrak from "./modules/madrak";
import marital from "./modules/marital";
import tadris from "./modules/tadris";
import morkhasi from "./modules/morkhasi";
import tadrisPermission from "./modules/tadris-permission";
import deleteCourse from "./modules/delete-course";
import picture from "./modules/picture";
import global from "./global";
import getters from "./getters";

Vue.use(vuex);

const store = new vuex.Store({
  modules: {
    errorLog,
    global,
    user,
    message,
    cycle,
    payeh,
    hozoor,
    khorooj,
    transfer,
    resume,
    salary,
    schools,
    homeRequest,
    sabtenam,
    links,
    ertebat,
    madrak,
    marital,
    tadris,
    morkhasi,
    tadrisPermission,
    deleteCourse,
    picture,
  },
  getters,
});

export default store;
